<template>
  <div>
    <div>
      <el-select v-model="cabinetCode" placeholder="请选择">
        <el-option
          v-for="item in city"
          :key="item.id"
          :label="item.companyName"
          :value="item.cabinetCode"
        >
        </el-option>
      </el-select>
      <el-date-picker
        size="mini"
        v-model="firstDay"
        type="datetime"
        format="yyyy-MM-dd"
        placeholder="选择日期时间"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-button type="primary" size="mini" @click="openList()"
        >获取本地电芯数据</el-button
      >
    </div>
    <el-select v-model="value" placeholder="请选择" @change="handleValueChange">
      <el-option
        v-for="item in options"
        :key="item.label"
        :label="item.label"
        :value="item.label"
      >
      </el-option>
    </el-select>
    <el-card>
      <div class="ibtn-box" v-if="flag">
        <div
          ref="charts1"
          style="
            height: 500px;
            margin-top: 20px;
            margin-bottom: 40px;
            width: 100%;
          "
        ></div>
      </div>
    </el-card>
    <el-dialog
      title="获取本地电芯数据"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-select v-model="fileType" placeholder="请选择文件" size="mini">
        <el-option
          v-for="item in fileList"
          :key="item.filePath"
          :label="item.fileName"
          :value="item.filePath"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="initData()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-table :data="data2" style="width: 100%" v-if="flag">
      <el-table-column prop="date" label="名字" width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.maxName + "," + scope.row.minName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="max" label="最大值" width="180"> </el-table-column>
      <el-table-column prop="min" label="最小值"> </el-table-column>
      <el-table-column prop="time" label="时间"> </el-table-column>
    </el-table>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { AxiosAjax } from "../../js/axios.config";
import JSZip from "jszip";
import Papa from "papaparse";
import axios from "axios";

export default {
  data() {
    return {
      csvData: [],
      options: [
        {
          value: "1",
          label: "1#单体电压的数据",
        },
        {
          value: "2",
          label: "2#单体电压的数据",
        },
        {
          value: "3",
          label: "3#单体电压的数据",
        },
        {
          value: "4",
          label: "4#单体电压的数据",
        },
      ],
      value: "1#单体电压的数据",
      time: [],
      time1: [],
      voltage: {},
      data1: [],
      firstDay: "",
      dialogVisible: false,
      fileList: [],
      fileType: "",
      listData: [],
      cha: {
        // "1#单体电压的数据": {
        //   "1#1单体电压的数据": ["3213", "3213", "3213", "3213"],
        //   "1#2单体电压的数据": ["3213", "3213"],
        //   "1#3单体电压的数据": ["3213", "3213"],
        //   "1#4单体电压的数据": ["3213", "3213"],
        //   "1#5单体电压的数据": ["3213", "3213"],
        // },
        // "2#单体电压的数据": {
        //   "2#1单体电压的数据": ["3213", "3213"],
        //   "2#2单体电压的数据": ["3213", "3213"],
        // },
        // "3#单体电压的数据": {
        //   "3#1单体电压的数据": ["3213", "3213"],
        //   "3#2单体电压的数据": ["3213", "3213"],
        // },
        // "4#单体电压的数据": {
        //   "4#1单体电压的数据": ["3213", "3213"],
        //   "4#2单体电压的数据": ["3213", "3213"],
        //   "4#3单体电压的数据": ["3213", "3213"],
        // },
      },
      cha1: {},
      difference1: [],
      difference2: [],
      difference3: [],
      difference4: [],
      data2: [],
      city: [],
      cabinetCode: "",
      flag: true,
    };
  },
  mounted() {
    this.getContent();
  },
  beforeDestroy() {},
  methods: {
    getContent() {
      let _this = this;
      let sendUrl = "/cabinet/cabinet/page/v2";
      sendUrl += "?size=" + 9999;
      sendUrl += "&index=" + 1;

      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.city = res.data.data.content;
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    //加载数据
    initData() {
      let _this = this;
      let sendUrl;
      this.city.forEach((item) => {
        if (item.cabinetCode == _this.cabinetCode) {
          sendUrl = "/cabinet/cabinet/" + item.id + "/filePage";
        }
      });
      sendUrl += "?size=" + 999;
      sendUrl += "&index=" + 1;
      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content;
          _this.dialogVisible = false;
          _this.handleClick();
        },
        error: function (err) {
          _this.listData = null;
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    async handleClick() {
      let item = this.listData[0];
      this.$message.success("数据正在处理中");
      try {
        if (!item.absolutePath) {
          return;
        }
        const response = await axios({
          url: item.absolutePath,
          method: "GET",
          responseType: "blob",
        });
        // 2. 使用JSZip解压ZIP文件
        const zip = new JSZip();
        const content = await zip.loadAsync(response.data);

        // 3. 遍历ZIP文件中的所有文件，查找CSV文件
        let csvBlob = null;
        for (const fileName in content.files) {
          if (fileName.endsWith(".csv")) {
            // 检查文件扩展名是否为.csv
            csvBlob = await content.file(fileName).async("blob");
            break; // 假设我们只需要处理第一个找到的CSV文件
          }
        }

        if (!csvBlob) {
          this.$message.error("数据处理失败");
          throw new Error("No CSV file found in the ZIP archive.");
        }

        // 将Blob转换为文本
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
          reader.onload = (event) => {
            const csvText = event.target.result;

            // 4. 使用Papa Parse解析CSV文本
            const parsedData = Papa.parse(csvText, { header: true }); // 根据CSV是否有标题行设置header的值

            this.csvData = parsedData.data; // 存储解析后的数据
            //数据进一步解析需要的
            this.dataProcessing();
            //数据抽样
            this.downSampling();

            // 计算差值
            this.difference();
            // 在这里可以进一步处理或展示csvData
            this.$message.success("数据处理成功");

            this.drawChart();
            this.data2 = this.difference1;
            resolve(); // 解析完成后，resolve这个Promise
          };
          reader.onerror = reject; // 读取错误时，reject这个Promise
          reader.readAsText(csvBlob);
        });
      } catch (error) {
        this.$message.error("数据处理失败");

        console.error("Error downloading, extracting, or parsing CSV:", error);
      }
    },
    // 进行抽样

    downSampling() {
      this.cha1 = {};
      this.time1 = [];
      for (const key in this.cha) {
        this.cha1[key] = {};
        for (const key1 in this.cha[key]) {
          this.cha1[key][key1] = [];

          for (let i = 0; i < this.cha[key][key1].length; i++) {
            if (i % 500 == 0) {
              this.cha1[key][key1].push(this.cha[key][key1][i]);
            }
          }
        }
      }
      for (let i = 0; i < this.time.length; i++) {
        if (i % 500 == 0) {
          this.time1.push(this.time[i]);
        }
      }
    },

    difference() {
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let data4 = [];
      // 遍历对象数组并提取单体电压信息
      this.csvData.forEach((obj) => {
        let extreme1 = this.calculateVoltageExtremes(obj, "1#");
        if (extreme1) {
          data1.push(extreme1);
        }
        let extreme2 = this.calculateVoltageExtremes(obj, "2#");
        if (extreme2) {
          data2.push(extreme2);
        }
        let extreme3 = this.calculateVoltageExtremes(obj, "3#");
        if (extreme3) {
          data3.push(extreme3);
        }
        let extreme4 = this.calculateVoltageExtremes(obj, "4#");
        if (extreme4) {
          data4.push(extreme4);
        }
      });
      this.difference1 = this.minMax(data1);
      this.difference2 = this.minMax(data2);
      this.difference3 = this.minMax(data3);
      this.difference4 = this.minMax(data4);
    },
    calculateVoltageExtremes(obj, prefix) {
      const voltages = [];
      for (let i = 1; i <= 216; i++) {
        const voltageKey = `${prefix}${i}单体电压`;
        if (voltageKey in obj) {
          voltages.push(parseInt(obj[voltageKey], 10)); // 假设电压是整数
        }
      }
      if (voltages.length > 0) {
        const minVoltage = Math.min(...voltages);
        const maxVoltage = Math.max(...voltages);
        if (maxVoltage - minVoltage > 100) {
          return {
            min: minVoltage,
            max: maxVoltage,
            time: obj["时间"],
            minName: this.findMinName(obj, prefix), // 需要一个额外的函数来找到最小值的编号
            maxName: this.findMaxName(obj, prefix), // 需要一个额外的函数来找到最大值的编号
          };
        }
      }
      return null;
    },
    minMax(objects) {
      let maxDiff = -Infinity;
      let data = [];
      // 遍历对象数组
      for (let obj of objects) {
        // 计算当前对象的差值
        let diff = obj.max - obj.min;

        // 如果当前差值大于已知的最大差值，则更新最大差值和对应的对象
        if (diff > maxDiff) {
          maxDiff = diff;
          data = [obj];
        } else if (diff === maxDiff) {
          data.push(obj);
        }
      }

      return data;
    },

    findMinName(obj, prefix) {
      let minName = null;
      let minValue = Infinity;
      for (let i = 1; i <= 216; i++) {
        const voltageKey = `${prefix}${i}单体电压`;
        if (voltageKey in obj && parseInt(obj[voltageKey], 10) < minValue) {
          minValue = parseInt(obj[voltageKey], 10);
          minName = voltageKey;
        }
      }
      return minName;
    },
    // 辅助函数用于找到具有最大电压值的编号
    findMaxName(obj, prefix) {
      let maxName = null;
      let maxValue = -Infinity;
      for (let i = 1; i <= 216; i++) {
        const voltageKey = `${prefix}${i}单体电压`;
        if (voltageKey in obj && parseInt(obj[voltageKey], 10) > maxValue) {
          maxValue = parseInt(obj[voltageKey], 10);
          maxName = voltageKey;
        }
      }
      return maxName;
    },

    dataProcessing() {
      const transformedData = {
        time: [],
        "1#单体电压的数据": {},
        "2#单体电压的数据": {},
        "3#单体电压的数据": {},
        "4#单体电压的数据": {},
      };

      this.csvData.forEach((item, index) => {
        transformedData.time.push(item["时间"]);

        // 遍历每个单体电压的数据
        for (let i = 1; i <= 216; i++) {
          const voltageKey = `1#${i}单体电压`;
          const voltageDataKey = `1#${i}单体电压的数据`;
          if (item.hasOwnProperty(voltageKey)) {
            if (
              !transformedData["1#单体电压的数据"].hasOwnProperty(
                voltageDataKey
              )
            ) {
              transformedData["1#单体电压的数据"][voltageDataKey] = [];
            }
            transformedData["1#单体电压的数据"][voltageDataKey].push(
              item[voltageKey]
            );
          }
        }
        for (let i = 1; i <= 216; i++) {
          const voltageKey = `2#${i}单体电压`;
          const voltageDataKey = `2#${i}单体电压的数据`;
          if (item.hasOwnProperty(voltageKey)) {
            if (
              !transformedData["2#单体电压的数据"].hasOwnProperty(
                voltageDataKey
              )
            ) {
              transformedData["2#单体电压的数据"][voltageDataKey] = [];
            }
            transformedData["2#单体电压的数据"][voltageDataKey].push(
              item[voltageKey]
            );
          }
        }
        for (let i = 1; i <= 216; i++) {
          const voltageKey = `3#${i}单体电压`;
          const voltageDataKey = `3#${i}单体电压的数据`;
          if (item.hasOwnProperty(voltageKey)) {
            if (
              !transformedData["3#单体电压的数据"].hasOwnProperty(
                voltageDataKey
              )
            ) {
              transformedData["3#单体电压的数据"][voltageDataKey] = [];
            }
            transformedData["3#单体电压的数据"][voltageDataKey].push(
              item[voltageKey]
            );
          }
        }
        for (let i = 1; i <= 216; i++) {
          const voltageKey = `4#${i}单体电压`;
          const voltageDataKey = `4#${i}单体电压的数据`;
          if (item.hasOwnProperty(voltageKey)) {
            if (
              !transformedData["4#单体电压的数据"].hasOwnProperty(
                voltageDataKey
              )
            ) {
              transformedData["4#单体电压的数据"][voltageDataKey] = [];
            }
            transformedData["4#单体电压的数据"][voltageDataKey].push(
              item[voltageKey]
            );
          }
        }
      });

      this.time = transformedData.time;
      delete transformedData.time;
      this.cha = transformedData;
    },

    drawChart() {
      var series = [];

      for (const key1 in this.cha1[this.value]) {
        var seriesObj = {
          name: key1,
          type: "line",
          data: this.cha1[this.value][key1],
        };
        series.push(seriesObj);
      }
      this.$nextTick(() => {
        const chartRef = this.$refs.charts1;
        if (chartRef) {
          this.chart = echarts.init(chartRef, null, {
            renderer: "canvas",
            large: true,
          });
          let option = {};
          option = {
            title: {
              text: this.value,
              left: "left",
              textStyle: {
                color: "#333",
                fontSize: 18,
                fontWeight: "bold",
              },
            },
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                let html = '<div style="max-height: 200px; overflow: auto;">'; // 设置最大高度和溢出滚动
                html += "<p>时间: " + params[0].name + "</p>"; // 添加时间
                params.forEach((param) => {
                  html += `<p>${param.seriesName}: ${param.value}</p>`; // 添加数据和系列名称
                });
                html += "</div>";
                return html;
              },
            },
            xAxis: {
              type: "category",
              data: this.time1,
            },
            yAxis: {
              type: "value",
              data: [2000, 4000],
              min: 2000,
            },
            series: series,
          };
          this.chart.setOption(option);
        }
      });
    },
    handleValueChange() {
      if (Object.keys(this.cha1[this.value]).length === 0) {
        this.$message.error("没有数据，请选择其他");
        this.flag = false;
        return;
      }
      if (this.value == "1#单体电压的数据") {
        this.data2 = this.difference1;
      } else if (this.value == "2#单体电压的数据") {
        this.data2 = this.difference2;
      } else if (this.value == "3#单体电压的数据") {
        this.data2 = this.difference3;
      } else if (this.value == "4#单体电压的数据") {
        this.data2 = this.difference4;
      }
      this.flag = true;
      this.drawChart();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    openList() {
      const _this = this;
      this.fileList = [];
      const params = {
        cabinetCode: _this.cabinetCode,
        dateTime: this.firstDay,
      };
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/getLogList",
        data: params,
        success: function (res) {
          _this.dialogVisible = true;
          if (res.data.data.data.fileInfos.length > 0) {
            res.data.data.data.fileInfos.forEach((item) => {
              if (item.fileName.includes("Monomer-")) {
                _this.fileList.push(item);
              }
            });
          }
        },
      });
    },
  },
};
</script>
<style scoped>
.mainbody,
.histroy_list {
  display: flex;
}
.font_w600 {
  font-weight: 600;
}
.el-card {
  margin: 10px;
}
.histroy_list {
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
}
.histroy_list p {
  flex: 1;
  text-align: left;
}
.histroy_list p:last-child {
  text-align: right;
}
.block {
  margin: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Monitor/Voltage.vue